import { render } from "./RxDate.vue?vue&type=template&id=08cd6ec6&scoped=true"
import script from "./RxDate.vue?vue&type=script&lang=js"
export * from "./RxDate.vue?vue&type=script&lang=js"

import "./RxDate.vue?vue&type=style&index=0&id=08cd6ec6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08cd6ec6"]])

export default __exports__